import { render, staticRenderFns } from "./Miniapps.vue?vue&type=template&id=4121b8b8&scoped=true&"
import script from "./Miniapps.vue?vue&type=script&lang=js&"
export * from "./Miniapps.vue?vue&type=script&lang=js&"
import style0 from "./Miniapps.vue?vue&type=style&index=0&id=4121b8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121b8b8",
  null
  
)

export default component.exports